module.exports = __webpack_public_path__ + "static/img/01.66311a92.jpg";